import { render, staticRenderFns } from "./info-pc-width.vue?vue&type=template&id=f1fb275e&"
import script from "./info-pc-width.vue?vue&type=script&lang=js&"
export * from "./info-pc-width.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports